import { AnimationComponent } from './/animation.component';
import * as _ from 'lodash';

export class CbsBasicsComponent extends AnimationComponent {

  public scaleX: any;
  public scaleY: any;

  constructor (
    public iconService,
  ) {
    super();
  }

  public async calculateValues() {
    // Copy all parameters to values
    this.values = _.clone(this.parameters);
    if (!this.values['size']) {
      this.values['size'] = {'value': [this.values['width'], this.values['height']]};
    }
    this.width = this.values['size']['value'][0];
    this.height = this.values['size']['value'][1];
    // Reset the fontList
    this.fontList = _.clone(this.standardFontList);
    // Add the icon font to the fontlist
    this.fontList.push((this.values['icon'] || {})['font']);
    // Figure out some values to use in drawing the animation later
  };

  public drawIcon(selection, values) {
    selection.append('text')
      .attr('x', values['iconOffsetX'])
      .attr('y', values['iconOffsetY'])
      .attr('fill', values['colorScheme']['value'][0])
      .attr('stroke', values['colorScheme']['value'][1])
      .attr('stroke-width', values['iconStrokeWidth'] * 2)
      .attr('font-family', values['icon']['font'])
      .attr('font-size', values['iconFontSize'])
      .text(values['icon']['letter']);
    selection.append('text')
      .attr('x', values['iconOffsetX'])
      .attr('y', values['iconOffsetY'])
      .attr('fill', values['colorScheme']['value'][0])
      .attr('stroke', 'none')
      .attr('font-family', values['icon']['font'])
      .attr('font-size', values['iconFontSize'])
      .text(values['icon']['letter']);
  }

  public drawSVGIcon(selection, values) {
    let inner = this.iconService.getIcon(values['icon'], 'binnenvorm', { 'x': values['iconOffsetX'], 'y': values['iconOffsetY'], 'width': values['iconWidth'], 'preserveAspectRatio': 'xMinYMin' }, { 'fill': values['colorScheme']['value'][0], 'stroke': 'none' });
    let outer = this.iconService.getIcon(values['icon'], 'buitenvorm', { 'x': values['iconOffsetX'], 'y': values['iconOffsetY'], 'width': values['iconWidth'], 'preserveAspectRatio': 'xMinYMin' }, { 'fill': values['colorScheme']['value'][1], 'stroke': 'none' });
    selection.append(outer);
    selection.append(inner);
    return selection;
  }

  public drawTitleText1(selection, values, font) {
    selection.append('text')
      .attr('x', values['titleOffsetX'])
      .attr('y', values['title1OffsetY'])
      .attr('fill', values['titleColor'])
      .attr('font-family', font)
      .attr('font-size', values['titleFontSize'])
      .attr('font-weight', values['titleFontWeight'])
      .text(values['titleText1']);
  }

  public drawTitleText2(selection, values, font) {
    selection.append('text')
      .attr('x', values['titleOffsetX'])
      .attr('y', values['title2OffsetY'])
      .attr('fill', values['titleColor'])
      .attr('font-family', font)
      .attr('font-size', values['titleFontSize'])
      .attr('font-weight', values['titleFontWeight'])
      .text(values['titleText2']);
  }

  public drawBackground(selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', values['bannerHeight'] > 0 ? values['colorScheme']['value'][1] : values['colorScheme']['value'][0])
      .attr('stroke', 'none');
    if (values['bannerHeight'] > 0) {
      selection.append('rect')
        .attr('x', 0)
        .attr('y', values['bannerHeight'])
        .attr('width', values['width'])
        .attr('height', values['backgroundPaneHeight'])
        .attr('fill', values['colorScheme']['value'][0])
        .attr('stroke', 'none')
        .attr('rx', values['backgroundBorderRadius'])
        .attr('ry', values['backgroundBorderRadius']);
      selection.append('rect')
        .attr('x', 0)
        .attr('y', values['bannerHeight'] + values['backgroundBorderRadius'])
        .attr('width', values['width'])
        .attr('height', values['backgroundPaneHeight'] - values['backgroundBorderRadius'])
        .attr('fill', values['colorScheme']['value'][0])
        .attr('stroke', 'none');
    } else {

    }
  }
}



// WEBPACK FOOTER //
// ./src/app/animations/animation-base-classes/cbs-basics.component.ts